import { importHighcharts } from '@/lib/highcharts'
import { BlockModule } from '../common'
import {
    baseLineChartConfig,
    doIfInViewOrDefer,
    setupChartCounters,
    trendColorClasses,
    trendIconClasses,
} from './common'
import { getMarketDataExternalSectorCurrentAccount } from '@/api'
import { defineComponent } from 'vue'
import ChartShareButtons from '@/components/website/ChartShareButtons.vue'

new BlockModule({
    selector: '.block-market-data-external-sector-current-account',
    vueComponent: defineComponent({
        components: { ChartShareButtons },
        setup() {},
    }),
    async setupBlock(el, onTeardown, blockContext) {
        const chartData = await getMarketDataExternalSectorCurrentAccount()

        const latestValue = chartData.data[chartData.data.length - 1]
        const beforeLatestValue = chartData.data[chartData.data.length - 2]
        const valueDelta = (latestValue.y || 0) - (beforeLatestValue.y || 0)

        const timestamp = chartData.lastUpdated
        const date = new Date(timestamp)
        const lastUpdatedValue = date
            .toLocaleDateString('en-US', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
            })
            .replace(',', '')
        let trend: keyof typeof trendColorClasses & keyof typeof trendIconClasses = 'neutral'

        if (valueDelta > 0) {
            trend = 'positive'
        } else if (valueDelta < 0) {
            trend = 'negative'
        }

        const setupChart = async () => {
            const chartEl = el.querySelector('.chart-container')
            if (!chartEl) return

            const Highcharts = await importHighcharts()

            Highcharts.setOptions({
                lang: {
                    numericSymbols: undefined,
                },
            })

            const chartConfig = {
                ...baseLineChartConfig,
                chart: {
                    ...baseLineChartConfig.chart,
                    renderTo: chartEl as HTMLElement,
                },
                xAxis: {
                    ...baseLineChartConfig.xAxis,
                    categories: chartData.data.map((x) => x.x.toString()),
                },
                exporting: {
                    enabled: false,
                    filename: 'market-data-external-sector-current-account',
                },
            }
            const chart = Highcharts.chart({
                ...chartConfig,
                series: [
                    {
                        name: chartData.yLabel,
                        type: 'line',
                        color: '#010066',
                        data: chartData.data.map((x) => x.y),
                    },
                ],
            })

            const download = el.querySelector<HTMLButtonElement>('.download-btn')
            if (download) {
                download.addEventListener('click', () => {
                    chart.downloadCSV()
                })
            }

            onTeardown(() => {
                chart.destroy()
            })
        }

        doIfInViewOrDefer(() => {
            setupChart()
            setupChartCounters(
                el,
                trend,
                latestValue,
                beforeLatestValue,
                null,
                valueDelta,
                timestamp,
                lastUpdatedValue,
                null,
                null,
                null,
                null,
                false,
            )
        }, blockContext)
    },
})
